import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import DeliveryForm from './forms/DeliveryForm';
import DeliveryList from './lists/DeliveryList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import moment from "moment";
import {list} from "../../utils/array";
import ContextBased from "./Context/ContextBased";
import {connect} from "react-redux";

class DeliveryEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        const values = {
            location: this.props.pos?.location ? this.props.pos?.id : undefined,
            // moment( ).format("YYYY-MM-DD HH:mm:ss")
            dispatcher: this.props.user.id,
            state: this.props.componentEditor === "MainMenuDelivery" ? 0 : 1,
            reception_date: this.props.componentEditor === "MainMenuDelivery" ? null : moment().format("YYYY-MM-DD HH:mm:ss"),
            recipient:  this.props.componentEditor === "MainMenuDelivery" ? this.props.user.id : null
        };
        await this.props.setInitialValues(values);
        await this.props.setFormValues(values);
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
        this.props.componentEditor === "MainMenuDelivery" && await this.pristineForm();
    }

    nextState = async () => {
        // await this.saveForm;
        await this.props.processAction(async ({componentAction}) => {
            await componentAction('changeState', {user_id: this.props.user.id});
        });
    }



    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const state = parseInt(this.props.values.state || "0");

        let nextStateButton = null;
        if (state < 2 &&  this.props.componentEditor !== "MainMenuDelivery" && this.props.selection.id) {
            nextStateButton = (
                <Button
                    key="1"
                    disabled={this.props.isLoading}
                    color="primary"
                    className="pull-right"
                    onClick={this.nextState}
                >
                    {!state ? "Beérkezett" : "Átadva"}
                </Button>
            );
        }

        const list = <List
            {...this.props}
            pristineForm={this.pristineForm}
            loadForm={this.loadForm}
            saveForm={this.saveForm}
            collapsed={this.props.collapsed || false}
            theme="default"
            header="Küldemények"
            footer={[
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ]}
        >
            <DeliveryList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
        </List>;

        const editor = <Editor
            {...this.props}
            pristineForm={this.pristineForm}
            loadForm={this.loadForm}
            saveForm={this.saveForm}
            ref={(editor) => this.editor = editor}
            theme="default"
            header="Küldemény adatai"
            footer={[
                <Button
                    key="0"
                    disabled={!this.props.dirty || this.props.isLoading}
                    color="primary"
                    className="pull-right"
                    onClick={this.saveForm}
                >
                    Mentés
                </Button>,
                nextStateButton,
                this.props.componentEditor !== "MainMenuDelivery"
                &&
                !!this.props.values[this.props.componentConfig.idfield]
                &&
                (state === 0 || state === 3)
                &&
                <Button
                    key="2"
                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                    color="danger"
                    className="pull-left"
                    onClick={this.props.deleteForm}
                >
                    Törlés
                </Button>

            ]}
        >
            <DeliveryForm {...this.props} />
        </Editor>;

        return(
            this.props.componentEditor !== "MainMenuDelivery" ?
            <>
                {list}
                {editor}
            </> :
                <>
                    {editor}
                    <h4>Korábbi küldeményeim</h4>
                    {list}
                </>
        )

    }
}

const Editor = createEditor({
    componentName: "Delivery",
    WrappedComponent: DeliveryEditor
});

const FilteredEditor = (props) => {
    let {listFilter} = props;
    listFilter = props.editorContext !== "MainMenuDelivery" ?
        list(listFilter, {field: "location", value: props.pos.id}) : [];
    return <Editor {...props} listFilter={listFilter} />;
}

export default connect((state) => ({
    user: state.app.user,
}))((props) => <ContextBased needle={["pos"]}>
    <FilteredEditor {...props} />
</ContextBased>);
